export const getAdverts = (payload?: any) => ({
    type: "@saga/GET_ADVERTS",
    payload
});

